import { useEffect, useState } from 'react';
import { Stack, Text, Title, Button, Group } from '@mantine/core';
import { IconRefresh } from '@tabler/icons-react';
import SnappedEndMill from './SnappedEndMill';

const POLL_MS = 5000;
const FAIL_THRESHOLD = 2;

export default function ConnectionLostOverlay() {
  const [down, setDown] = useState(false);
  const [fails, setFails] = useState(0);

  useEffect(() => {
    let alive = true;
    async function tick() {
      try {
        const ctl = new AbortController();
        const to = setTimeout(() => ctl.abort(), 4000);
        const res = await fetch('/api/v1/health', { credentials: 'include', cache: 'no-store', signal: ctl.signal });
        clearTimeout(to);
        if (!alive) return;
        if (res.ok) {
          setFails(0);
          setDown(false);
        } else {
          setFails((n) => n + 1);
        }
      } catch {
        if (!alive) return;
        setFails((n) => n + 1);
      }
    }
    tick();
    const id = setInterval(tick, POLL_MS);
    return () => { alive = false; clearInterval(id); };
  }, []);

  useEffect(() => { if (fails >= FAIL_THRESHOLD) setDown(true); }, [fails]);

  if (!down) return null;

  return (
    <div
      aria-modal
      role="dialog"
      style={{
        position: 'fixed',
        inset: 0,
        background: 'rgba(0,0,0,0.78)',
        zIndex: 10000,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backdropFilter: 'blur(3px)',
      }}
    >
      <div style={{
        maxWidth: 460,
        background: 'var(--mantine-color-body)',
        border: '1px solid var(--mantine-color-red-4)',
        borderRadius: 8,
        padding: 28,
        textAlign: 'center',
        boxShadow: '0 12px 48px rgba(0,0,0,0.5)',
      }}>
        <Stack align="center" gap="md">
          <div style={{ color: 'var(--mantine-color-red-6)' }}>
            <SnappedEndMill size={180} />
          </div>
          <Title order={2} c="red">CNC End Mill has snapped</Title>
          <Text c="dimmed">
            The connection to the CYCLOTRON server has been lost. This is most likely
            due to <strong>improper programming</strong> — feed rate, spindle speed, or
            depth of cut outside the tool's limits.
          </Text>
          <Text size="sm" c="dimmed">
            The app will reconnect automatically as soon as the server is reachable again.
          </Text>
          <Group>
            <Button leftSection={<IconRefresh size={14} />} variant="filled" color="red" onClick={() => window.location.reload()}>
              Retry now
            </Button>
          </Group>
        </Stack>
      </div>
    </div>
  );
}
